import {
  PLAYER_INIT,
  PLAYER_START,
  PLAYER_TOGGLE,
  PLAYER_SEEK_TO,
  PLAYER_SEEK_RESET,
  PLAYER_UPDATE_PROGRESS,
  PLAYER_SET_ACTIVE_CUEPOINT,
  PLAYER_UNLOAD,
  PLAYER_REMOVE,
} from '../actions/playerActions';


const defaultPlayerState = {
  activeCuePoint: {},
  isPlaying: false,
  playProgress: {},
  posterHidden: false,
  seekTo: null,
  videoId: null,
};

export const players = (state = {}, action) => {
  const uid = action.payload ? action.payload.uid : null;

  switch (action.type) {
    case PLAYER_INIT:
      return {
        ...state,
        [uid]: {
          ...defaultPlayerState,
          ...action.payload.properties,
        },
      };
    case PLAYER_START:
      return {
        ...state,
        [uid]: {
          ...state[uid],
          isPlaying: true,
          posterHidden: true,
        },
      };
    case PLAYER_TOGGLE:
      return {
        ...state,
        [uid]: {
          ...state[uid],
          isPlaying: action.payload.isPlaying,
        },
      };
    case PLAYER_SEEK_TO:
      return {
        ...state,
        [uid]: {
          ...state[uid],
          seekTo: action.payload.time,
          isPlaying: true,
          posterHidden: true,
        },
      };
    case PLAYER_SEEK_RESET:
      return {
        ...state,
        [uid]: {
          ...state[uid],
          seekTo: null,
        },
      };
    case PLAYER_UPDATE_PROGRESS:
      return {
        ...state,
        [uid]: {
          ...state[uid],
          playProgress: action.payload.progress,
        },
      };
    case PLAYER_SET_ACTIVE_CUEPOINT:
      return {
        ...state,
        [uid]: {
          ...state[uid],
          activeCuePoint: action.payload.data,
        },
      };
    case PLAYER_UNLOAD: {
      const playerObj = {
        ...state[uid],
        isPlaying: false,
        posterHidden: false,
        activeCuePoint: {},
      };
      // Reset playhead only if play has begun
      if (Object.keys(state[uid].playProgress).length !== 0) {
        playerObj.seekTo = 0;
      }
      return {
        ...state,
        [uid]: { ...playerObj },
      };
    }
    case PLAYER_REMOVE:
      const { [uid]: toRemove, ...rest } = state;
      return { ...rest };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/playerReducer.js